import ActionBar from './ActionBar'
import List from './List'
import TaxDetail from './TaxDetail'
import {connect} from 'react-redux'
import {
  taxesPageRequest,
  // cancelDeleteTax,
  deleteTax,
  confirmTaxAssignToItem,
  cancelDelete
} from 'actions/library/tax'
import LibraryDeleteModal from 'components/LibraryDeleteModal'
import {askConfirmAction} from 'actions/confirm-action'
import {isDirty} from 'redux-form'
import {browserHistory} from 'react-router'
import {push} from 'react-router-redux'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import NoDataAndLoading from 'components/NoDataAndLoading'
import SaveToAllOutletsModal from './SaveToAllOutletsModal'
import TaxAssignToItemModal from './TaxAssignToItemModal'
import * as mpLibraryTax from 'mixpanel/library/tax'
import _isEqual from 'lodash/isEqual'
import _without from 'lodash/without'
import _map from 'lodash/map'

class Tax extends React.Component {
  render () {
    let {showDeleteModal, deletedTax, openRightColumn, showLoadingSpinnerPage, taxes} = this.props
    let taxName = deletedTax ? deletedTax.name : ''

    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={taxes.length === 0}
              title='No Data To Display'
              description='' />
            <List />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <TaxDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <TaxAssignToItemModal onSubmit={this._onSubmitTaxAssignToItem} />
        <SaveToAllOutletsModal />
        <LibraryDeleteModal
          showDeleteModal={showDeleteModal}
          onHide={this._onHideModal}
          title='Tax'
          name={taxName}
          onDelete={this._onDelete}
        />
        <ConfirmActionModal />
      </PageWrapper>
    )
  }

  componentDidMount () {
    const {expired} = this.props
    if (!expired) {
      this.props.dispatch(taxesPageRequest())
      browserHistory.listenBefore((location) => {
        const {taxDetail} = this.props
        const {taxAssignToItem} = this.props
        let isDirtyAssign = false
        if (taxAssignToItem && taxDetail) {
          const initialItemIds = _without(_map(taxDetail.loaded_items, 'item_id'), undefined)
          const currentItemIds = taxAssignToItem.values.itemIds
          isDirtyAssign = !(_isEqual(initialItemIds.sort(), currentItemIds.sort()))
        } else { // Do nothing
        }

        // this is still hacky, don't copy paste this
        if ((this.props.isDirtyTax || isDirtyAssign) && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  _onDelete = () => {
    let {dispatch, taxes, deletedTax, taxDetail, categories} = this.props
    dispatch(deleteTax(deletedTax.id, taxes, taxDetail, categories))
  }

  _onHideModal = () => {
    this.props.dispatch(cancelDelete())
  }

  _onSubmitTaxAssignToItem = (values) => {
    const {dispatch, taxDetail, tax} = this.props
    if (taxDetail.id === null) {
      mpLibraryTax.libraryTaxCreateAssignItemApply(taxDetail)
    } else {
      mpLibraryTax.libraryTaxEditAssignItemApply(taxDetail)
    }
    dispatch(confirmTaxAssignToItem(taxDetail, tax))
  }
}

function mapStateToProps (state) {
  let {taxes, taxDetail, showDeleteModal, deletedTax, openRightColumn, setting, categories, taxAssignToItems} = state.library.tax
  let {taxAssignToItem, tax} = state.form
  const isDirtyTax = isDirty('tax')(state)
  const {nextAction} = state.confirmAction
  const {showLoadingSpinnerPage} = state.loadingSpinner
  const {expired} = state.subscriptionExpired
  return {
    taxes,
    taxDetail,
    showDeleteModal,
    deletedTax,
    isDirtyTax,
    nextAction,
    openRightColumn,
    showLoadingSpinnerPage,
    expired,
    setting,
    categories,
    taxAssignToItems,
    taxAssignToItem,
    tax
    // state
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Tax)



// WEBPACK FOOTER //
// ./app/pages/Library/Tax/Tax.js